import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=2e7d332a&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=2e7d332a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7d332a')) {
      api.createRecord('2e7d332a', component.options)
    } else {
      api.reload('2e7d332a', component.options)
    }
    module.hot.accept("./CustomerInfo.vue?vue&type=template&id=2e7d332a&", function () {
      api.rerender('2e7d332a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Edit/CustomerInfo.vue"
export default component.exports